const acceptImageTypes = 'image/png,image/jpeg,image/jpg'
const acceptPdf = 'application/pdf'

/**
 * Check file is image.
 *
 * @param {File} file
 * @returns {boolean} isImage
 */
export function checkImageOrFail(file) {
  let isImage = file && acceptImageTypes.includes(file.type)
  let isAllowSize = file && Math.floor(file.size / 1024 / 1024) < 10

  if (!isImage) {
    throw new Error(`File ${file.name} is not image.`)
  }

  // if (!isAllowSize) {
  //   console.log("file size is too long")
  //   throw new Error(`File ${file.name} too big, please select a file less than 10mb.`)
  // }

  return isImage 
}

export function checkPdfOrFail(file) {
  let isImage = file && acceptPdf.includes(file.type)
  let isAllowSize = file && Math.floor(file.size / 1024 / 1024) < 10

  if (!isImage) {
    throw new Error(`File ${file.name} is not a pdf.`)
  }

  // if (!isAllowSize) {
  //   throw new Error(`File ${file.name} too big, please select a file less than 10mb.`)
  // }

  return isImage && isAllowSize
}

/**
 * Check file is image.
 *
 * @param {File} file
 * @returns {boolean} isImage
 */
export function checkImage(file) {
  let result

  try {
    result = checkImageOrFail(file)
  } catch (error) {
    result = false
  }

  return result
}
